export default "__VITE_ASSET__x2VOeZm0__"